import Vuex from 'vuex'
import Vue from 'vue'
import user from './modules/user'
import tabStatus from './modules/tabStatus'
// import selfMachineUser from './modules/selfMachineUser'
Vue.use(Vuex)

let store = new Vuex.Store({
  modules: {
    user,
    tabStatus
    // selfMachineUser
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js